<template>
  <CRow>
    <div class="curtain"></div>

    <div class="main" @click="modal_patients = false" :class="classCurtain">
      <CModal
        :show.sync="modalPacienteBaixa"
        :no-close-on-backdrop="true"
        :centered="true"
        title="Aviso"
        color="warning"
      >
      <h4>Paciente já teve data da baixa registrada.</h4>
      <p>Deseja prosseguir e retirar a data da baixa?</p>

        <div class="d-flex gap-2">
          <CButton @click="retirarDataBaixa()" color="info"
          >Sim</CButton
        >
        <CButton @click="cancelarRegistro" color="info" variant="outline"
          >Cancelar</CButton>
        </div>
      </CModal>
      <CModal
        :show.sync="modalDataOcupada"
        :no-close-on-backdrop="true"
        :centered="true"
        title="Modal title 2"
        color="warning"
      >
        <CAlert
          color="warning"
          id="aviso"
          name="sucesso"
          :show.sync="alertaAvisoHorario"
          closeButton
          >{{ mensagem }}</CAlert
        >
        <table>
          <tr></tr>
          <tr v-for="elem of consultasData" :key="elem.id">
            <div
              v-if="
                elem.error == 'profissional_ocupation' ||
                elem.error == 'sala_ocupation'
              "
            >
              <td>
                <div>
                  <CInput
                    class="inline_block"
                    type="date"
                    required
                    v-model="elem.dataModal"
                    autocomplete="complemento"
                    invalid-feedback="Convenio obrigatorio"
                  >
                  </CInput>

                  <CSelect
                    class="inline_block"
                    :options="listaHorario"
                    v-model="elem.hora"
                    required
                  ></CSelect>
                  <CButton @click="salvarConsultaModal(elem)" color="info"
                    >Salvar</CButton
                  >
                </div>
                <p class="p_message">{{ elem.message }}</p>
              </td>
            </div>
          </tr>
        </table>

        <template #header>
          <h4 class="modal-title">
            Por favor, troque a data ou a hora da consulta
          </h4>
          <CButtonClose @click="cancelar()" class="text-white" />
        </template>
      </CModal>
      <CModal
        :no-close-on-backdrop="true"
        :centered="true"
        title="Modal title 2"
        color="warning"
        v-show="showModal"
      >
        <CDataTable
          :items="dadosPacienteMulta"
          :fields="fields"
          hover
          sorter
          small
          pagination
        >
          <template #acao="{ item, index }">
            <td>
              <CInputCheckbox square @click="marcar(item, index)"
                >EXCLUIR</CInputCheckbox
              >
            </td>
          </template>
          >
        </CDataTable>
        <template #header>
          <h4 class="modal-title">Paciente tem debito de outras consultas</h4>
          <CButtonClose @click="cancelar()" class="text-white" />
        </template>
        <template>
          <CButton @click="cancelar()" color="info">Voltar</CButton>
          <CButton
            style="margin-left: 0.5em"
            @click="confirmValue()"
            color="success"
            >Somar</CButton
          >
        </template>
      </CModal>
      <CModal class="modal-excluir-consulta" :show.sync="mostrarModal">
        <div class="div-body-modal">
          <img
            src="../../../assets/atencao.jpg"
            width="120px"
            height="120px"
            alt=""
          />
          <h4>ATENÇÃO</h4>
          <p>{{ msgModal }}</p>

          <button
            type="button"
            class="btn-modal"
            style="margin-right: 10px"
            @click="mostrarModal = false"
          >
            CANCELAR
          </button>
          <button type="button" @click="irPerfilProfissional()">
            <router-link
              class="router-cadastro-convenio"
              :to="{
                path: '/profissionais',
                name: 'Profissionais',
                query: { id: consulta.profissional, type: 'b' },
              }"
              >CADASTRAR CONVÊNIO</router-link
            >
          </button>
        </div>
      </CModal>
      <CCol>
        <CCard>
          <CCardBody>
            <CAlert
              color="danger"
              id="aviso"
              name="aviso"
              :show.sync="mostraAllertaValidacaoCampo"
              closeButton
              >{{ mensagem }}</CAlert
            >
            <CAlert
              color="danger"
              id="aviso"
              name="aviso"
              :show.sync="validacoes.aviso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >

            <CAlert
              color="success"
              id="aviso"
              name="sucesso"
              :show.sync="validacoes.sucesso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >
            <CAlert
              color="success"
              id="aviso"
              name="sucesso"
              :show.sync="alertaSucesso"
              closeButton
              >{{ mensagem }}</CAlert
            >

            <CForm @submit="onSubmit($event)">
              <CTabs>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Dados de Cadastro
                  </template>
                  <br />
                  <CRow>
                    <CSelect
                      :value.sync="serviceSelecionado"
                      :options="servicos"
                      required
                      prepend="SERVIÇO"
                      placeholder=" "
                      @change="tipoServico()"
                    >
                    </CSelect>
                    <CCol col="6" v-show="camposService.escopo_dados">
                      <CCard>
                        <CCardBody>
                          <CInputCheckbox
                            label="PROAP"
                            v-show="camposService.proap"
                            required
                            autocomplete="email"
                            invalid-feedback="Email é obrigatório"
                            :checked="consulta.checkProap"
                            @click="checkProapFunction"
                          >
                            <template #append-content>
                              <CIcon name="cil-at" />
                            </template>
                          </CInputCheckbox>
                          <CInput
                            type="search"
                            prepend="PACIENTE"
                            aria-label="Search"
                            aria-describedby="search-addon"
                            v-model="patient"
                            @change="populaDadosPaciente"
                          >
                            <template #append-content>
                              <CIcon name="cil-at" />
                            </template>
                          </CInput>
                          <div
                            v-if="filteredPatients && modal_patients"
                            class="div-ul-li"
                          >
                            <ul>
                              <li
                                class="li-list-patient"
                                v-for="filteredPatient in filteredPatients"
                                :key="filteredPatient"
                                @click="setPatient(filteredPatient)"
                              >
                                {{ filteredPatient.label }}
                              </li>
                            </ul>
                          </div>
                          <!-- <CSelect
                            :value.sync="pacienteSelecionado"
                            :options="pacientes"
                            required
                            v-show="camposService.paciente"
                            v-model="consulta.patient"
                            prepend="PACIENTE"
                            invalid-feedback="Nome é obrigatório"
                            @change="selecionaPaciente"
                          >
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CSelect> -->

                          <CInput
                            prepend="EMAIL"
                            v-model="consulta.email"
                            v-show="camposService.email"
                            required
                            autocomplete="email"
                            invalid-feedback="Email é obrigatório"
                            disabled
                          >
                            <template #append-content>
                              <CIcon name="cil-at" />
                            </template>
                          </CInput>

                          <CInput
                            required
                            v-model="consulta.telefone"
                            v-show="camposService.telefone"
                            prepend="TELEFONE"
                            invalid-feedback="Telefone Contato é obrigatório"
                            disabled
                          >
                            <template #append-content>
                              <CIcon name="cil-phone" />
                            </template>
                          </CInput>
                          <CSelect
                            :value.sync="consulta.profissional"
                            :options="listaProfissionais"
                            required
                            v-show="camposService.profissional"
                            v-model="consulta.profissional"
                            placeholder=" "
                            prepend="PROFISSIONAL"
                            ref="profissional"
                            invalid-feedback="Nome é obrigatório"
                            :disabled="disabled_profissional"
                            @change="changeProfessional()"
                          >
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CSelect>
                          <CInput
                            type="date"
                            required
                            v-model="consulta.data"
                            prepend="DIA"
                            v-show="camposService.data"
                            autocomplete="complemento"
                            invalid-feedback="Convenio obrigatorio"
                            @blur="showFields"
                            :disabled="disabled_dia"
                          >
                          </CInput>

                          <CCard
                            style="border: none"
                            class="field-recorrencia"
                            v-show="camposService.recorrencia"
                          >
                            <div
                              class="div-section"
                              @change="exibirDataRecorrencia"
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input radio"
                                  type="radio"
                                  name="recorrencia"
                                  id="two"
                                  v-model="recorrencia"
                                  :value="'0'"
                                  :disabled="disabled_recurrences"
                                  @change="resetArrDate"
                                />
                                <label
                                  style="margin-left: 10px"
                                  class="form-check-label"
                                  for="two"
                                >
                                  Sem recorrencia
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input radio"
                                  type="radio"
                                  name="recorrencia"
                                  id="one"
                                  v-model="recorrencia"
                                  :value="'7'"
                                  :disabled="disabled_recurrences"
                                  @change="resetArrDate"
                                />
                                <label
                                  style="margin-left: 10px"
                                  class="form-check-label"
                                  for="one"
                                >
                                  Recorrência Semanal
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input radio"
                                  type="radio"
                                  name="recorrencia"
                                  id="two"
                                  v-model="recorrencia"
                                  :value="'14'"
                                  :disabled="disabled_recurrences"
                                  @change="resetArrDate"
                                />
                                <label
                                  style="margin-left: 10px"
                                  class="form-check-label"
                                  for="two"
                                >
                                  Recorrência Quinzenal
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input radio"
                                  type="radio"
                                  name="recorrencia"
                                  id="thre"
                                  v-model="recorrencia"
                                  :value="'28'"
                                  :disabled="disabled_recurrences"
                                  @change="resetArrDate"
                                />
                                <label
                                  style="margin-left: 10px"
                                  class="form-check-label"
                                  for="three"
                                >
                                  Recorrência Mensal
                                </label>
                              </div>
                            </div>
                            <div
                              style="margin-left: 10%"
                              v-show="dataRecorrenciaFinal"
                            >
                              <CInput
                                style="
                                  width: 16vw;
                                  margin: -6vw 12vw;
                                  text-align: center;
                                "
                                required
                                type="date"
                                v-model="data_final_recorrencia"
                                prepend="DATA"
                                autocomplete="complemento"
                                invalid-feedback="Convenio obrigatorio"
                                @blur="verificaData()"
                                :disabled="disabled_recurrences"
                              >
                              </CInput>
                            </div>
                          </CCard>
                          <!-- <CInput
                            type="time"
                            v-model="consulta.hora"
                            required
                            v-show="camposService.hora"
                            prepend="HORA"
                            @blur="verificaHoraConsulta()"
                            :disabled="disabled_tempo"
                          >
                          </CInput> -->
                          <CSelect
                            type="time"
                            :options="listaHorario"
                            v-model="consulta.hora"
                            required
                            v-show="camposService.hora"
                            prepend="HORA"
                            @change="verificaHoraConsulta()"
                            :disabled="disabled_tempo"
                          >
                          </CSelect>
                          <CSelect
                            :value.sync="salaSelecionada"
                            :options="listaSalas"
                            v-model="consulta.sala"
                            required
                            v-show="camposService.sala"
                            prepend="SALA"
                            placeholder=" "
                            invalid-feedback="Nome é obrigatório"
                            @change="selecionaSala"
                            :disabled="disabled_sala"
                          >
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CSelect>

                          <CInput
                            v-model="consulta.andar"
                            prepend="ANDAR"
                            required
                            v-show="camposService.andar"
                            autocomplete="nome"
                            disabled
                          >
                            <template #append-content>
                              <CIcon name="cil-bank" />
                            </template>
                          </CInput>

                          <CSelect
                            :options="tempoConsulta"
                            required
                            v-model="consulta.tempo_consulta"
                            prepend="TEMPO"
                            ref="tempo"
                            placeholder=" "
                            autocomplete="complemento"
                            invalid-feedback="Convenio obrigatorio"
                            v-show="camposService.tempo"
                            :disabled="disabled_tempo"
                            @change="changeTempo()"
                          >
                          </CSelect>

                          <section
                            class="section-option"
                            style="
                              padding: 10px;
                              color: #676f7b;
                              margin-bottom: 20px;
                            "
                          ></section>

                          <CInput
                            v-model="consulta.valorMulta"
                            prepend="MULTA"
                            required
                            autocomplete="nome"
                            v-show="showInputMulta"
                          >
                            <template #append-content>
                              <CIcon name="cil-bank" />
                            </template>
                          </CInput>
                         <CInput
                              v-model="consulta.valor"
                              prepend="VALOR"
                              @input="formatValue()"
                              type="text"
                              required
                              ref="valor"
                              v-show="camposService.valor"
                              autocomplete="nome"
                             
                            >
                            <template #append-content>
                              <CIcon name="cil-bank" />
                            </template>
                          </CInput>
                        </CCardBody>
                      </CCard>
                    </CCol>
                    <CCol col="6" v-show="camposService.convenio_escopo">
                      <CCard>
                        <CCardBody>
                          <h3>Convênio</h3>
                          <CRow>
                            <CCol col="12">
                              <CSelect
                                :value.sync="consulta.id_convenio"
                                :options="listInsurance"
                                v-model="consulta.id_convenio"
                                required
                                v-show="camposService.c_convenio"
                                prepend="CONVÊNIO"
                                invalid-feedback="Nome é obrigatório"
                                @change="selecionaConvenio"
                              >
                                <template #append-content>
                                  <CIcon name="cil-badge" />
                                </template>
                              </CSelect>
                            </CCol>
                            <CCol col="6">
                              <CInput
                                required
                                v-model="consulta.numGuia"
                                prepend="NUM. GUIA 1"
                                v-show="camposService.c_numGuia"
                                invalid-feedback="Email é obrigatório"
                                :disabled="guiaDisabled"
                              >
                                <template #append-content>
                                  <CIcon name="cil-at" />
                                </template>
                              </CInput>
                            </CCol>

                            <CCol col="6">
                              <CInput
                                type="date"
                                required
                                v-model="consulta.dataGuia1"
                                prepend="DATA GUIA 1"
                                v-show="camposService.c_numGuia"
                                :disabled="guiaDisabled"
                              >
                              </CInput>
                            </CCol>

                            <CCol col="6">
                              <CInput
                                required
                                v-model="consulta.numGuia2"
                                prepend="NUM. GUIA 2"
                                v-show="showGuia2"
                                invalid-feedback="Email é obrigatório"
                                :disabled="guiaDisabled"
                              >
                                <template #append-content>
                                  <CIcon name="cil-at" />
                                </template>
                              </CInput>
                            </CCol>

                            <CCol col="6">
                              <CInput
                                type="date"
                                required
                                v-model="consulta.dataGuia2"
                                prepend="DATA GUIA 2"
                                v-show="showGuia2"
                                :disabled="guiaDisabled"
                              >
                              </CInput>
                            </CCol>
                            <CCol col="6">
                              <CInput
                                required
                                v-model="consulta.protocolo2"
                                prepend="PROTOCOLO 2"
                                v-show="showGuia2"
                                invalid-feedback="Email é obrigatório"
                                :disabled="guiaDisabled"
                              >
                                <template #append-content>
                                  <CIcon name="cil-at" />
                                </template>
                              </CInput>
                            </CCol>

                            <div>
                              <div>
                                <CInput
                                  type="date"
                                  required
                                  v-model="consulta.data_inicio"
                                  prepend="COBRANÇA "
                                  v-show="camposService.c_inicio"
                                  autocomplete="complemento"
                                  invalid-feedback="Convenio obrigatorio"
                                  :disabled="inicioDisabled"
                                >
                                </CInput>
                              </div>
                              <div>
                                <CInput
                                  type="date"
                                  required
                                  v-model="consulta.data_final"
                                  prepend="RECEBIMENTO"
                                  v-show="camposService.c_fim"
                                  autocomplete="complemento"
                                  invalid-feedback="Convenio obrigatorio"
                                  :disabled="fimDisabled"
                                >
                                </CInput>
                              </div>
                            </div>
                          </CRow>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                  <CButton
                    color="success"
                    class="m-2"
                    @click="cadastrarConsulta()"
                    :disabled="btn_cadastro_consulta"
                    >Cadastrar</CButton
                  >
                  <CButton color="info" class="m-2" @click="voltar()"
                    >Voltar</CButton
                  >
                </CTab>
              </CTabs>
            </CForm>
          </CCardBody>
        </CCard>
        <CAlert
          color="danger"
          id="aviso"
          name="aviso"
          :show.sync="mostraAllertaValidacaoCampo"
          closeButton
          >{{ mensagem }}</CAlert
        >
        <CAlert
          color="danger"
          id="aviso"
          name="aviso"
          :show.sync="validacoes.aviso"
          closeButton
          >{{ validacoes.msg }}</CAlert
        >
        <CAlert
          color="success"
          id="aviso"
          name="sucesso"
          :show.sync="alertaSucesso"
          closeButton
          >{{ mensagem }}</CAlert
        >
      </CCol>
      <CAlert
        color="warning"
        id="aviso"
        name="sucesso"
        :show.sync="alertaAviso"
        closeButton
        >{{ mensagem }}</CAlert
      >
    </div>
  </CRow>
</template>
<script>
import moment from "moment";
import "moment/locale/pt-br";
import Table from "../../base/Table.vue";

export default {
  components: { Table },
  data() {
    return {
       moneyMask() {
      return (value) => {
        // Remove tudo que não é dígito
        const digits = value.replace(/\D+/g, '');
        const length = digits.length;

        // Cria a máscara com base na quantidade de dígitos
        if (length <= 6) {
          return '###.###,##';
        } else if (length <= 9) {
          return '#.###.###,##';
        } else if (length <= 12) {
          return '##.###.###,##';
        } else {
          return '###.###.###,##'; // ajuste para mais dígitos, se necessário
        }
      };
    },
      cpf: "###.###.###-##",
      telefone: "(##) #####.####",
      cep: "#####-###",
      mensagem: "",
      mostrarModal: false,
      msgModal: "",
      spinner_curtain: false,
      div_curtain: false,
      btn_cadastro_consulta: false,
      classCurtain: {
        activeCurtain: false,
      },
      mostraAllertaValidacaoCampo: false,
      guiaDisabled: true,
      protocoloDisabled: true,
      inicioDisabled: true,
      fimDisabled: true,
      checkProap: false,
      disabled_recurrences: true,
      disabled_hora: true,
      disabled_tempo: true,
      disabled_profissional: true,
      disabled_sala: true,
      disabled_dia: true,
      disabled_valor: true,

      filter_patient: "",

      patient: "",
      id_patient: "",
      patients: [],
      modal: false,
      filteredPatients: [],

      // Servico
      serviceSelecionado: "",
      servicos: [
        { label: "CONSULTA", value: "1" },
        { label: "AVALIAÇÃO", value: "2" },
        { label: "CURSO", value: "3" },
        { label: "PALESTRA", value: "4" },
      ],
      // Campos para visible
      camposService: {
        proap: false,
        paciente: false,
        email: false,
        telefone: false,
        profissional: false,
        sala: false,
        andar: false,
        data: false,
        cpf: false,
        tempo: false,
        recorrencia: false,
        hora: false,
        valor: false,
        convenio_escopo: false,
        escopo_dados: false,
        c_convenio: false,
        c_numGuia: false,
        c_inicio: false,
        c_fim: false,
      },
      listaHorario: [
        { label: " ", value: " " },
        { label: "07:00", value: "07:00" },
        { label: "07:30", value: "07:30" },
        { label: "08:00", value: "08:00" },
        { label: "08:30", value: "08:30" },
        { label: "09:00", value: "09:00" },
        { label: "09:30", value: "09:30" },
        { label: "10:00", value: "10:00" },
        { label: "10:30", value: "10:30" },
        { label: "11:00", value: "11:00" },
        { label: "11:30", value: "11:30" },
        { label: "12:00", value: "12:00" },
        { label: "12:30", value: "12:30" },
        { label: "13:00", value: "13:00" },
        { label: "13:30", value: "13:30" },
        { label: "14:00", value: "14:00" },
        { label: "14:30", value: "14:30" },
        { label: "15:00", value: "15:00" },
        { label: "15:30", value: "15:30" },
        { label: "16:00", value: "16:00" },
        { label: "16:30", value: "16:30" },
        { label: "17:00", value: "17:00" },
        { label: "17:30", value: "17:30" },
        { label: "18:00", value: "18:00" },
        { label: "18:30", value: "18:30" },
        { label: "19:00", value: "19:00" },
        { label: "19:30", value: "19:30" },
        { label: "20:00", value: "20:00" },
        { label: "20:30", value: "20:30" },
        { label: "21:00", value: "21:00" },
      ],
      tempoConsulta: [
        { label: "25 minutos", value: 0.5 },
        { label: "50 minutos", value: 1 },
      ],
      validacoes: {
        msg: "",
        sucesso: false,
        aviso: false,
        statusData: "",
        statusHora: "",
        statusSala: "",
        statusRecoData: "",
        statusRecoHora: "",
        statusRecoSala: "",
        modal_reco_msg: "",
        ifs: false,
      },
      alertaAviso: false,
      alertaSucesso: false,
      optionModal: {
        hora: "",
        data: "",
        option: "",
        optionDate: false,
        optionTime: false,
      },

      changeOptionModal: false,

      darkModal: true,
      dataRecorrenciaFinal: false,
      multasPaciente: [],
      proximaConsulta: "",
      modalPacienteBaixa: false,
      modalDataOcupada: false,
      consultasData: [],
      showGuia2: false,
      consulta: {
        service: "",
        idUser: "",
        checkProap: false,
        patient: "",
        nome: "",
        cpf: "",
        telefone: "",
        email: "",
        profissional: "",
        data: "",
        tempo_consulta: "",
        hora: "",
        sala: "",
        andar: "",
        valor: "",
        numGuia: "",
        valorMulta: "0",
        id_convenio: "",
        data_inicio: "",
        data_final: "",
        protocolo: "",
        protocolo2: "",
        nf: "",
        numGuia2: "",
        dataGuia1: "",
        dataGuia2: "",
        countRecorrencia: 0,
        notify: true,
      },
      dangerModal: false,
      recorrencia: "0",
      data_final_recorrencia: "",
      multaSelecionada: "",
      showInputMulta: false,
      showModal: false,
      dadosPacienteMulta: [],
      fields: [
        {
          key: "date_at",
          label: "Data da consulta",
          _style: "min-width:100px",
        },
        { key: "hour_at", label: "Hora", _style: "min-width:20px;" },
        { key: "name", label: "Profissional", _style: "min-width:180px;" },
        { key: "multa", label: "Valor", _style: "min-width:40px;" },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],

      fieldsDataConsulta: [
        {
          key: "data",
          label: "Data",
          _style: "min-width:100px",
        },
        {
          key: "hora",
          label: "Hora",
          _style: "min-width:100px",
        },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      paramVoltar: false,

      //profissional
      listaProfissionais: [],
      profissionalSelecionado: "",
      percentage: "",
      valorClinica: "",
      comissao: "",

      //paciente
      listaPaciente: [],
      pacientes: [{ label: "", value: "" }],
      pacienteSelecionado: "",
      dadosPaciente: {
        email: "",
        telefone: "",
      },
      // insurance
      listInsurance: [{ label: "", value: "" }],

      // contagem para validar modal
      count: 0,
      //sala
      salas: [],
      listaSalas: [],
      salaSelecionada: "",
      dadosSala: {
        andar: "",
      },
      variable_verify_params: false,
      modal_patients: false,
      isLoading: false,
      verificar_horario_modal: "",
      query: "",
      paramsCalendar: "",
      hasError: 0,
      alertaAvisoHorario: false,
    };
  },

  methods: {
 formatValue() {
  
  if (this.consulta.valor) {
    let numericValue = this.consulta.valor.replace(/[^0-9,]/g, '');
    numericValue = parseInt(numericValue.replace(',', '.'), 10);
    if (!isNaN(numericValue)) {
      const formattedNumber = numericValue / 100;
      const numeroFormatado = formattedNumber.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      
      this.consulta.valor = numeroFormatado.slice(3).replace(',', '.');
      
      
    } else {
      this.consulta.valor = '';
    }
  }
},
    async showFields() {
      this.consulta.hora = null;
      this.listaSalas = [];

      if (this.consulta.data) {
        this.disabled_recurrences = false;
        this.disabled_tempo = false;
      } else {
        this.disabled_recurrences = true;
        this.disabled_tempo = true;
      }

      await this.listarSalas();
      await this.verificaData();
      this.count = 0;
      this.consulta.hora = "";
    },
    // Selecionar o tipo de serviço
    tipoServico() {
      this.consulta.service = this.serviceSelecionado;

      let user = localStorage.getItem("type_name");

      let option = this.serviceSelecionado;

      switch (option) {
        case "1":
          this.camposService.proap = true;
          this.camposService.paciente = true;
          this.camposService.email = true;
          this.camposService.telefone = true;
          this.camposService.profissional = true;
          this.camposService.sala = true;
          this.camposService.andar = true;
          this.camposService.data = true;
          this.camposService.tempo = true;
          this.camposService.recorrencia = true;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = true;
          this.camposService.c_convenio = true;
          this.camposService.c_numGuia = true;
          this.camposService.c_inicio = true;
          this.camposService.escopo_dados = true;
          this.camposService.c_fim = true;
          break;
        case "2":
          this.camposService.proap = true;
          this.camposService.paciente = true;

          this.camposService.email = true;
          this.camposService.telefone = true;
          this.camposService.profissional = true;
          this.camposService.sala = true;
          this.camposService.andar = true;
          this.camposService.data = true;
          this.camposService.tempo = true;
          this.camposService.recorrencia = false;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = false;
          this.camposService.escopo_dados = true;
          this.camposService.c_convenio = false;
          this.camposService.c_numGuia = false;
          this.camposService.c_inicio = false;
          this.camposService.c_fim = false;
          break;
        case "3":
          this.camposService.proap = false;
          this.camposService.paciente = false;
          this.camposService.email = false;
          this.camposService.telefone = false;
          this.camposService.profissional = true;
          this.camposService.sala = true;
          this.camposService.andar = true;
          this.camposService.data = true;
          this.camposService.tempo = false;
          this.camposService.recorrencia = false;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = false;
          this.camposService.escopo_dados = true;
          this.camposService.c_convenio = false;
          this.camposService.c_numGuia = false;
          this.camposService.c_inicio = false;
          this.camposService.c_fim = false;
          break;
        case "4":
          this.camposService.proap = false;
          this.camposService.paciente = false;
          this.camposService.email = false;
          this.camposService.telefone = false;
          this.camposService.profissional = true;
          this.camposService.sala = false;
          this.camposService.andar = false;
          this.camposService.data = true;
          this.camposService.tempo = false;
          this.camposService.recorrencia = false;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = false;
          this.camposService.escopo_dados = true;
          this.camposService.c_convenio = false;
          this.camposService.c_numGuia = false;
          this.camposService.c_inicio = false;
          this.camposService.c_fim = false;
          break;

        default:
      }
    },
    retirarDataBaixa(){
      this.$http.get(`${process.env.VUE_APP_API_BASE_URL}paciente/baixa/atualizar/${this.consulta.patient}`)
        .then((res)=>{
          this.modalPacienteBaixa = false
        })
    },
    cancelarRegistro(){
      this.patient = ''
      this.modalPacienteBaixa = false
      this.consulta.patient = ''
      this.consulta.email = ''
      this.consulta.telefone = ''
      this.consulta.profissional = ''
    },
    selecionaConvenio() {
      if (this.consulta.id_convenio == 1 || this.consulta.id_convenio == 6) {
        (this.guiaDisabled = true),
          (this.protocoloDisabled = true),
          (this.inicioDisabled = true),
          (this.fimDisabled = true);
      } else {
        (this.guiaDisabled = false),
          (this.protocoloDisabled = false),
          (this.inicioDisabled = false),
          (this.fimDisabled = false);
      }

      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}value-percentage`, {
          id_profissional: this.consulta.profissional,
          id_convenio: this.consulta.id_convenio,
        })
        .then((res) => res.json())
        .then((res) => {
          this.btn_cadastro_consulta = true;
          if (res[0].valorConvenio == false) {
            this.mostrarModal = true;
            this.msgModal = `Profissional não tem valor do convênio cadastrado no seu perfil`;
          } else {
            this.btn_cadastro_consulta = false;
          }
        });
    },
    somavalores() {
      // this.consulta.valor =
      //   this.consulta.valor + this.consulta.valorMulta
      //     ? this.consulta.valorMulta
      //     : 0;
      //this.consulta.valor = parseFloat(this.consulta.valor).toFixed(2);
      //this.consulta.valor + this.consulta.valorMulta
       // ? this.consulta.valorMulta
       // : 0;
    },
    cancelar() {
      this.darkModal = false;
      this.modalDataOcupada = false;
    },
    confirmValue() {
      let value = 0;
      this.dadosPacienteMulta.forEach((item) => {
      console.log({ item })
        if (item.marcado == true) {
          this.multaSelecionada = item;
          value = value + item.multa;
        }
      });
      this.consulta.valorMulta = value;
      this.showInputMulta = true;
      this.showModal = false;
    },
    marcar(item, index) {
      item.marcado = !item.marcado;
    },
    financialPatient() {
      if (this.consulta.patient != 0) {
        this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}financial/lista-multa/${this.consulta.patient}`
          )
          .then((res) => res.json())
          .then((res) => {
            if (this.consulta.patient != 0) {
              this.disabled_profissional = false;
            } else {
              this.disabled_profissional = true;
            }
            res.forEach((res) => {
              res.marcado = false;
              res.date_at = moment(res.date_at).format("DD/MM/YYYY");
            });

            this.dadosPacienteMulta = res;

            if (this.dadosPacienteMulta.length > 0) {
              if (localStorage.getItem("type") != 2) {
                this.showModal = true;
              }
            }
          });
      }
    },

    populaDadosPaciente() {
      this.classCurtain.activeCurtain = true;
      this.spinner_curtain = true;
      this.disabled_profissional = false;
      setTimeout(() => {
        this.listaPaciente.forEach((paciente) => {
          if (paciente.id == this.consulta.patient) {
            if (paciente.sick_leave != null) {
              this.modalPacienteBaixa = true
            }
            this.consulta.nome = paciente.patient;
            this.consulta.email = paciente.email;
            this.consulta.telefone = paciente.phone;
            this.consulta.cpf = paciente.cpf;
            this.consulta.nf = paciente.nf;
            this.consulta.id_convenio = paciente.insurance;

            if (!this.paramVoltar) {
              (this.consulta.profissional = paciente.id_professional),
                (this.disabled_dia = false);
            }

            // this.consulta.profissional = paciente.id_professional;
            // this.consulta.hora =
            if (paciente.id_professional != null) this.disabled_sala = false;

            this.selecionaConvenio();
            this.classCurtain.activeCurtain = false;
            this.spinner_curtain = false;
          }
        });

        this.financialPatient();
      }, 500);
    },

    listarSalas() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`${process.env.VUE_APP_API_BASE_URL}salas`)
          .then((res) => res.json())
          .then((res) => {
            this.initParams();
            this.salas = res;

            this.listaSalas.push({ label: "Online", value: 0 });
            res.forEach((item) => {
              this.listaSalas.push({
                label: `Sala: ${item.sala}`,
                value: item.sala,
              });
            });

            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    selecionaSala() {
      this.salaSelecionada = this.consulta.sala;
      this.salas.forEach((sala) => {
        if (this.salaSelecionada == 0) {
          this.consulta.andar = "-";
        }
        if (sala.sala == this.salaSelecionada) {
          this.consulta.andar = sala.andar;
        }
      });

      this.disabled_dia = false;
    },
    initParams() {
      this.paramsCalendar = this.$route.params;
      if (this.paramsCalendar.dia) {
        this.consulta.profissional = this.paramsCalendar.hora.id;
        this.consulta.sala = this.paramsCalendar.sala;
        this.salaSelecionada = this.paramsCalendar.sala;
        // this.changeProfessional();
        this.disabled_tempo = false;
        this.disabled_recurrences = false;
        this.consulta.data = moment(
          this.paramsCalendar.dia,
          "dddd DD/MM/YYYY"
        ).format("YYYY-MM-DD");
      }
    },
    listaPorfissionais() {
      let typeUser = localStorage.getItem("type_name");
      let idProfissional = localStorage.getItem("id");

      if (typeUser == "Profissional") {
        this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}profissionais/${idProfissional}`
          )
          .then((res) => res.json())
          .then((res) => {
            res.forEach((item) => {
              this.listaProfissionais.push({
                label: item.name.toUpperCase(),
                value: item.id,
                sala: item.sala,
              });
            });
            // this.initParams();
          });
      } else {
        this.$http
          .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
          .then((res) => res.json())
          .then((res) => {
            res.forEach((item) => {
              this.listaProfissionais.push({
                label: item.name.toUpperCase(),
                value: item.id,
                sala: item.sala,
              });
            });

            // this.initParams();
          });
      }
    },
    listaInsurance() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.listInsurance.push({
              label: item.name.toUpperCase(),
              value: item.id,
            });
          });
        });
    },
    async salvarConsultaModal(elem) {
      let closeModal = true;
      elem.data = moment(elem.dataModal).format("YYYY-MM-DD");

      try {
        const [res1, res2] = await Promise.all([
          this.$http.post(
            `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
            elem
          ),
          this.$http.post(
            `${process.env.VUE_APP_API_BASE_URL}valida-consulta`,
            elem
          ),
        ]);

        if (res1.status == 201 || res1.status == 203) {
          // Tratamento para resposta de res1
          if (res1.body.error == "profissional_ocupation") {
            this.mensagem = `Profissional ocupado às ${
              res1.body.consulta.hour_at
            } por ${
              res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
            }`;
          } else {
            this.mensagem = `Sala ocupada às ${
              res1.body.consulta.hour_at
            } por ${
              res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
            }`;
          }

          this.alertaAvisoHorario = true;
        }

        if (res2.status == 201 || res2.status == 203) {
          // Tratamento para resposta de res2

          this.alertaAvisoHorario = true;
          if (res2.body.error == "profissional_ocupation") {
            this.mensagem = `Profissional ocupado às ${
              res2.body.consulta.hour_at
            } por ${
              res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
            }`;
          } else {
            this.mensagem = `Sala ocupada às ${
              res2.body.consulta.hour_at
            } por ${
              res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
            }`;
          }
        }

        if (
          res1.status != 201 &&
          res1.status != 203 &&
          res2.status != 201 &&
          res2.status != 203
        ) {
          this.consultasData.forEach((elemento) => {
            if (elemento.id == elem.id) {
              elemento.error = null;

              this.modalDataOcupada = false;
              this.modalDataOcupada = true;

              if (elem.id == 0) {
                this.consulta.data = elem.data;
                this.consulta.hora = elem.hora;
              }
            }
          });
          this.consultasData.forEach((elem) => {
            if (elem.error != null) {
              this.consulta.valor = "";
              closeModal = false;
            }
          });

          const error = this.consultasData.find((x) => x.error != null);

          if (!error) {
            this.modalDataOcupada = false;
          } else {
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async verificaData() {
      this.consultasData = [];
      if (!this.variable_verify_params) {
        this.consulta.hora = "";
        this.consulta.valor = "";
        this.disabled_valor = true;
      }

      let d1 = this.consulta.data;

      // Data final
      let d2 = this.data_final_recorrencia;

      // Diferença dias
      let diff = moment(d2).diff(moment(d1));

      let diffDias = moment.duration(diff).asDays();

      // Intervalo de dias com base na recorrencia
      let intervalo = diffDias / this.recorrencia;
      // Arredondando valor
      let intervaloTratado = Math.floor(intervalo);

      this.consultasData.push({ data: d1 });
      for (let i = 0; i <= intervaloTratado - 1; i++) {
        d1 = moment(d1).add(this.recorrencia, "days").toDate();
        this.consultasData.push({ data: d1 });
      }

      
    },
    removerAcentosTrocarHifens(str) {
      var strSemAcentos = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      var strComUnderscores = strSemAcentos.replace(/-/g, "_");
      return strComUnderscores;
    },
    async retornaSala() {
      const dia = this.removerAcentosTrocarHifens(
        moment(this.consulta.data).format("dddd")
      );
      try {
        await this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}sala-consulta`, {
            dia,
            idProfessional: this.consulta.profissional,
            time: this.consulta.hora,
          })
          .then((res) => res.json())
          .then((res) => {
            this.consulta.sala = res[0].room;

            this.selecionaSala();

            for (let index = this.listaSalas.length - 1; index >= 0; index--) {
              const item = this.listaSalas[index];
              if (![0, this.consulta.sala].includes(item.value)) {
                this.listaSalas.splice(index, 1);
              }
            }
          });
      } catch (error) {}
    },
    async verificaHoraConsulta() {
      this.listaSalas = [];
      await this.listarSalas().then(() => {
        this.retornaSala();
      });
      const salas = this.listaSalas;

      this.modalDataOcupada = false;

      if (this.recorrencia == "0") {
        this.consultasData = [];

        this.consultasData.push({ data: this.consulta.data });
      }

      if (this.consulta.hora) {
        this.disabled_valor = false;
      } else {
        this.disabled_valor = true;
      }

      let id = 0;

      this.consultasData.forEach((elem) => {
        elem.id = id;
        elem.data = moment(elem.data).format("YYYY-MM-DD");
        elem.dataModal = moment(elem.data).format("YYYY-MM-DD");
        elem.hora = this.consulta.hora;
        elem.horaModal = this.consulta.hora;
        elem.sala = this.consulta.sala;
        elem.profissional = this.consulta.profissional;
        elem.patient = this.consulta.patient;
        id++;
      });
      this.consultasData.forEach(async (elem) => {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}valida-consulta`, elem)
          .then((res) => {
            if (res.status == 201 || res.status == 203) {
              elem.error = res.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado as ${
                  res.body.consulta.hour_at
                } por ${(res.body.consulta.consult_time = 1
                  ? "50 minutos"
                  : "25 minutos")}`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupado as ${
                  res.body.consulta.hour_at
                } por ${(res.body.consulta.consult_time = 1
                  ? "50 minutos"
                  : "25 minutos")}`;
              }
              // elem.message = `Horario ocupado: consulta as ${res.body.consulta.hour_at} de ${res.body.consulta.consult_time = 1?"50 minutos":"25 minutos"}`
              this.count = this.count + 1;
            } else {
              elem.error = null;
              if (this.recorrencia == 0) {
                this.consultasData.length = 0;
                this.count = 0;
              }
            }
          })
          .then(() => {
            const error = this.consultasData.filter((x) => x.error != null);
            if (error.length > 0) {
              setTimeout(() => {
                this.modalDataOcupada = true;
              }, 1000);
            }
          });
      });
    },

    checkProapFunction() {
      this.consulta.checkProap = !this.consulta.checkProap;
    },
    // validar campos de acordo com tipo de serviço
    validarCampos() {
      if (this.serviceSelecionado == "1") {
        if (!this.consulta.patient) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Paciente precisa ser preenchido";
        } else if (!this.consulta.profissional) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Profissional precisa ser preenchido";
        } else if (
          this.consulta.sala === null ||
          this.consulta.sala === undefined
        ) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Sala precisa ser selecionado";
        } else if (!this.consulta.data) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Data precisa ser preenchido";
        } else if (!this.consulta.tempo_consulta) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Tempo precisa ser preenchido";
        } else if (!this.consulta.hora) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Hora precisa ser preenchido";
        } else if (!this.consulta.valor) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Valor precisa ser preenchido";
        } else {
          this.validacoes.ifs = true;
        }
      }
      if (this.serviceSelecionado == "2") {
        if (!this.consulta.patient) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Paciente precisa ser preenchido";
        } else if (!this.consulta.profissional) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Profissional precisa ser preenchido";
        } else if (!this.consulta.sala) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Sala precisa ser selecionado";
        } else if (!this.consulta.data) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Data precisa ser preenchido";
        } else if (!this.consulta.hora) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Hora precisa ser preenchido";
        } else if (!this.consulta.valor) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Valor precisa ser preenchido";
        } else {
          this.validacoes.ifs = true;
        }
      }
      if (this.serviceSelecionado == "3") {
        if (!this.consulta.profissional) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Profissional precisa ser preenchido";
        } else if (!this.consulta.sala) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Sala precisa ser selecionado";
        } else if (
          this.consulta.data == null ||
          this.consutla.data == undefined
        ) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Data precisa ser preenchido";
        } else if (!this.consulta.hora) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Hora precisa ser preenchido";
        } else if (!this.consulta.valor) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Valor precisa ser preenchido";
        } else {
          this.validacoes.ifs = true;
        }
      }
      if (this.serviceSelecionado == "4") {
        if (!this.consulta.profissional) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Profissional precisa ser preenchido";
        } else if (!this.consulta.data) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Data precisa ser preenchido";
        } else if (!this.consulta.hora) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Hora precisa ser preenchido";
        } else if (!this.consulta.valor) {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Campo Valor precisa ser preenchido";
        } else {
          this.validacoes.ifs = true;
        }
      }
    },
    async validateSingleConsulta() {
      this.consultasData.forEach((elem) => {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
            elem
          )
          .then((res) => {
            if (res.status == 201 || res.status == 203) {
              elem.error = res.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado as ${
                  res.body.consulta.hour_at
                } por ${(res.body.consulta.consult_time = 1
                  ? "50 minutos"
                  : "25 minutos")}`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupada as ${
                  res.body.consulta.hour_at
                } por ${(res.body.consulta.consult_time = 1
                  ? "50 minutos"
                  : "25 minutos")}`;
              }
              this.count = this.count + 1;
            } else {
              return this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}valida-consulta`,
                elem
              );
            }
          })
          .then((res) => {
            if (res && (res.status == 201 || res.status == 203)) {
              elem.error = res.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado as ${
                  res.body.consulta.hour_at
                } por ${(res.body.consulta.consult_time = 1
                  ? "50 minutos"
                  : "25 minutos")}`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupada as ${
                  res.body.consulta.hour_at
                } por ${(res.body.consulta.consult_time = 1
                  ? "50 minutos"
                  : "25 minutos")}`;
              }
              this.count = this.count + 1;
            } else {
              elem.error = null;
              if (this.recorrencia == 0) {
                this.consultasData.length = 0;
                this.count = 0;
              }
            }

            const error = this.consultasData.filter((x) => x.error != null);
            if (error.length > 0) {
              setTimeout(() => {
                this.modalDataOcupada = true;
              }, 1000);
            }
          });
      });
    },
    // Cadastro da consulta
    async cadastrarConsulta() {
      this.validarCampos();

      await this.validateSingleConsulta();

      if (this.consultasData[0]?.error != null) {
        return;
      }

      if (!this.isLoading) {
        if (this.validacoes.ifs) {
          if (this.recorrencia == "0") {
            await this.$http
              .post(
                `${process.env.VUE_APP_API_BASE_URL}post-consulta`,

                this.consulta
              )
              .then((res) => {
                const porcentagemProfissional =
                  res.body.porcentagemProfissional;
                const porcentagemNome = res.body.porcentagemNome;

                let servico = "";
                switch (this.serviceSelecionado) {
                  case "1":
                    servico = "Consulta";
                    break;
                  case "2":
                    servico = "Avaliação";
                    break;
                  case "3":
                    servico = "Curso";
                    break;
                  case "4":
                    servico = "Palestra";
                    break;
                }

                this.alertaSucesso = true;
                this.mensagem = `${servico} cadastrada com sucesso`;
                this.btn_cadastro_consulta = true;
                setTimeout(() => {
                  this.$router.push("/consultas");
                }, 1000);
              });
          } else {
            for (let i = 0; i <= this.consultasData.length; i++) {
              try {
                this.consulta.data = this.consultasData[i].data;
                this.consulta.hora = this.consultasData[i].hora;
                if (i > 0) {
                  this.consulta.notify = false;
                  this.consulta.numGuia = null;
                  (this.consulta.dataGuia1 = null),
                    (this.consulta.numGuia2 = null),
                    (this.consulta.dataGuia2 = null);
                }
                this.isLoading = true;

                this.consulta.countRecorrencia++;

                await this.$http
                  .post(
                    `${process.env.VUE_APP_API_BASE_URL}post-consulta`,
                    this.consulta
                  )
                  .then((res) => {
                    this.alertaSucesso = true;
                    this.mensagem = "Consulta cadastrada com sucesso";
                    this.btn_cadastro_consulta = true;
                    setTimeout(() => {
                      this.$router.push("/consultas");
                    }, 1000);
                  });
              } catch (err) {
                this.dangerModal == true;
                while (this.dangerModal == true) {
                  setInterval(() => {}, 10000);
                }
                if (this.dangerModal == false) {
                  continue;
                }
              } finally {
                continue;
              }
            }
          }
        } else {
          this.modalDataOcupada = true;
        }
      } else {
        this.btn_cadastro_consulta = true;
      }
    },

    // modal while
    exibirOptionModal() {
      if (this.dangerModal) {
        this.changeOptionModal = true;
        if (this.optionModal.option == "1") {
          this.optionModal.optionTime = true;
          this.optionModal.optionDate = false;
          this.optionModal.data = "";
        } else if (this.optionModal.option == "2") {
          this.optionModal.optionDate = true;
          this.optionModal.optionTime = false;
          this.optionModal.hora = "";
        }
      }
    },
    resetArrDate() {
      if (this.consultasData > 1) {
        this.consultasData = [];
      }
      this.count = 0;
      this.consulta.hora = "";
    },
    enviarModal() {
      if (this.optionModal.hora) {
        this.consulta.hora = this.optionModal.hora;
        this.dangerModal = false;
      } else if (this.optionModal.data) {
        this.consulta.data = this.optionModal.data;
        this.dangerModal = false;
      }
    },
    modalWhile() {
      this.dangerModal = true;
      this.validacoes.modal_reco_msg =
        "Horário já cadastrado, prefere marcar para outro dia ou outro horário?";
    },
    exibirDataRecorrencia() {
      this.data_final_recorrencia = null;
      if (this.recorrencia == 0) {
        this.dataRecorrenciaFinal = false;
      } else {
        this.dataRecorrenciaFinal = true;
      }
    },
    filterPatient() {
      
      if (this.patient.length == 0) {
        this.modal_patients = false;
        this.patient = "";
        this.id_patient = "";
        this.consulta.email = "";
        this.consulta.telefone = "";
      } else {
        this.patient = this.patient;
        this.id_patient = this.id_patient;
        this.modal_patients = true;
      }
      
      this.patients.forEach((item)=>{
       
        if(item.value == 991){
          
        }
      })
      this.filteredPatients = this.patients.filter((item) => {
        return item.label.toLowerCase().startsWith(this.patient.toLowerCase());
      });
    },
    listarPaciente() {
      //// dados
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}pacientes`)
        .then((res) => res.json())
        .then((res) => {
          this.listaPaciente = res;
          
          res.forEach((item) => {
            if(item.id == 975){
              
            }
            this.patients.push({
              label: item.patient.toUpperCase(),
              value: item.id,
            });
          });
        });
    },
    setPatient(patient) {
      this.patient = patient.label;
      this.consulta.patient = patient.value;
      this.modal = false;
    },

    validaDataConsulta() {
      this.hasError = 0;
      const dataInit = this.consulta.data;
      return new Promise(async (resolve, reject) => {
        if (this.consulta.tempo_consulta == 1) {
          try {
            const promessas = this.consultasData.map(async (elem) => {
              this.consulta.data = elem.data;
              const res = await this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
                this.consulta
              );
              if (res.status == 201 || res.status == 203) {
                elem.error = res.body.error;

                if (elem.error == "profissional_ocupation") {
                  elem.message = `Profissional ocupado às ${
                    res.body.consulta.hour_at
                  } por ${
                    res.body.consulta.consult_time == 1
                      ? "50 minutos"
                      : "25 minutos"
                  }`;

                  this.hasError++;
                }
                if (elem.error == "sala_ocupation") {
                  elem.message = `Sala ocupada às ${
                    res.body.consulta.hour_at
                  } por ${
                    res.body.consulta.consult_time == 1
                      ? "50 minutos"
                      : "25 minutos"
                  }`;

                  this.hasError++;
                }
              }
            });
            this.consulta.data = dataInit;
            await Promise.all(promessas); // Aguarda a resolução de todas as promessas
            resolve();
          } catch (err) {
            reject(err);
          }
        }
      });
    },

    async changeTempo() {
      if (this.consulta.tempo_consulta == 1) {
        this.showGuia2 = true;
      } else {
        this.showGuia2 = false;
      }
      
      if (this.consultasData.length == 0) {
        let id = 0;
        this.consultasData = [
          {
            id: id,
            data: moment(this.consulta.data).format("YYYY-MM-DD"),
            dataModal: moment(this.consulta.data).format("YYYY-MM-DD"),
            hora: this.consulta.hora,
            horaModal: this.consulta.hora,
            sala: this.consulta.sala,
            profissional: this.consulta.profissional,
            patient: this.consulta.patient,
          },
        ];
      }
      this.validaDataConsulta().then((res) => {
        if (this.hasError > 0) {
          this.modalDataOcupada = true;
        }
      });
    },

    changeProfessional() {
      this.listaSalas = [];
      this.consulta.hora = null;
      this.listarSalas();

      this.disabled_dia = false;
      this.disabled_sala = false;
      const user = this.listaProfissionais.filter(
        (x) => x.value == this.consulta.profissional
      );
      this.consulta.sala = user[0].sala;
      this.salaSelecionada = user[0].sala;
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}value-percentage`, {
          id_profissional: this.consulta.profissional,
          id_convenio: this.consulta.id_convenio,
        })
        .then((res) => res.json())
        .then((res) => {
          this.btn_cadastro_consulta = true;
          if (res[0].valorConvenio == false) {
            this.mostrarModal = true;
            this.msgModal = `Profissional não tem valor do convênio cadastrado no seu perfil`;
          } else {
            this.btn_cadastro_consulta = false;
          }
        });
    },
  },
  watch: {
    patient() {
      this.filterPatient();
    },
  },

  mounted() {
    this.listarPaciente();
    this.serviceSelecionado = "1";
    this.tipoServico();
    this.consulta.idUser = localStorage.getItem("id");
    this.consulta.typeUser = localStorage.getItem("type_name");
    this.consulta.data = this.$route.params.data;
    this.paramVoltar = this.$route.params.voltar;
    if (this.consulta.data) {
      this.variable_verify_params = true;
      this.disabled_dia = false;
      this.disabled_tempo = false;
      this.disabled_recurrences = false;
      this.disabled_valor = false;
    } else {
      this.variable_verify_params = false;
      this.disabled_dia = true;
      this.disabled_tempo = true;
      this.disabled_recurrences = true;
      this.disabled_valor = true;
    }

    
    this.query = this.$route.query;

    // this.listarPaciente();

    this.listaPorfissionais();
    this.listaInsurance();
    this.listarSalas().then(() => {
      if (this.paramsCalendar.dia) {
        this.paramsCalendar = this.$route.params;
        this.consulta.sala = this.paramsCalendar.sala;
        this.salaSelecionada = this.paramsCalendar.sala;
        this.consulta.hora = this.paramsCalendar.item.name;
        this.selecionaSala();
        this.disabled_valor = false;
      }
    });
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Righteous&display=swap");

.div-options {
  margin-left: 20px;
  color: #626e76;
}
.pb-4,
.py-4 {
  padding: 10px !important;
}
.div-section {
  font-size: 14px;
}
.titulo-data-convneio {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 25px;
}
.field-recorrencia {
  display: flex;
}
.inline_block {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: -5px;
}
.input-group-text {
  width: 120px !important;
}
.li-list-patient {
  list-style: none;
  cursor: pointer;
  border-bottom: 1px solid black;
  margin-top: 10px;
}
.router-cadastro-convenio {
  color: white;
}
.router-cadastro-convenio:hover {
  color: red;
  text-decoration: none;
}
.inline_block {
  display: inline-block !important;
}
.p_message {
  font-size: 0.7rem;
}
</style>
